import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addSubscription,
  deleteSubscription,
  getAllPlanHistory,
  getSubscription,
  updateSubscription,
} from "store/services/SubscriptionPlans";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Subscription

export const GetAllSubscriptionAction = createAsyncThunk(
  "subscription/getSubscription",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getSubscription();
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//Add Subscription

export const AddSubscriptionAction = createAsyncThunk(
  "subscription/addSubscription",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const res = await addSubscription(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Update Subscription

export const UpdateSubscriptionAction = createAsyncThunk(
  "subscription/updateSubscription",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { onSuccess, ...rest } = payload;
      const res = await updateSubscription(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const DeleteSubscriptionAction = createAsyncThunk(
  "subscription/deleteSubscription",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await deleteSubscription(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue({ message: getApiMessage(res?.statusCode) });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

export const GetAllPlanHistory = createAsyncThunk(
  "subscription/getPlanHistory",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getAllPlanHistory(payload);
      if (res.status === 1) {
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
